import { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import APPURL from 'utils/app/urls'
import AppTools from 'utils/app/appTools'
import RegionTools from 'utils/regions/regionTools'
import IndicatorTools from 'utils/indicators/indicatorTools'

class HTMLTitleController extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props

    this.formatMessage = formatMessage

    this.state = {
      loading: true
    }
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setHTMLTitle()
  }

  setHTMLTitle() {
    const url = this.props.history.location.pathname
    const layer = APPURL.getLayerFromURL(url)

    if (this.state.loading) {
      let title = 'Orkestra'
      switch (layer) {
      case 0:
        title = `${this.formatMessage(messages.regional)} - ${this.formatMessage(messages.institute)}`
        break
      case 1:
        if (this.props.regionsData && this.props.selectedRegionId) {
          const selectedRegionName = RegionTools.getRegionNameFromId({ regionsData: this.props.regionsData, id: this.props.selectedRegionId })
          title = `${selectedRegionName} - ${this.formatMessage(messages.regional)}`
        }
        break
      case 2:
        if (this.props.regionsData && this.props.selectedRegionId) {
          const selectedRegionName = RegionTools.getRegionNameFromId({ regionsData: this.props.regionsData, id: this.props.selectedRegionId })
          const url = this.props.location.pathname
          const level = APPURL.getLevelFromURL(url)
          const dimensionTitle = AppTools.getDimensionTitle(level)

          title = `${dimensionTitle} - ${selectedRegionName}`
        }
        break
      case 3:
        if (this.props.regionsData && this.props.selectedRegionId && this.props.indicatorsData) {
          const selectedRegionName = RegionTools.getRegionNameFromId({ regionsData: this.props.regionsData, id: this.props.selectedRegionId })
          const url = this.props.location.pathname
          const indicatorId = APPURL.getIndicatorFromURL(url)
          const indicatorName = IndicatorTools.getIndicatorNameFromId({ indicatorsData: this.props.indicatorsData, id: indicatorId })

          title = `${indicatorName} - ${selectedRegionName}`
        }
        break
      case 'methodology':
        title = `${this.formatMessage(messages.methodology)} - ${this.formatMessage(messages.regional)}`
        break
      default:
        title = 'Orkestra'
        break
      }

      document.querySelector('head title').innerHTML = title
    }
  }

  render() {
    return ''
  }
}

export default injectIntl(HTMLTitleController)



// WEBPACK FOOTER //
// ./src/modules/Controllers/HTMLTitle/HTMLTitleController/HTMLTitleController.jsx